import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import { setModalStatus } from '../Actions/LanguageAndCountry.action';
import { translate } from '../Services/translation';
import { ModalStyles } from '../constants';
import constants from '../constants';
import CloseButton from './CloseButton';
import LanguageAndCountrySelector from './LanguageAndCountrySelector';

export default function Bnr() {

    let languageCode = constants.languages[0].value;
    let countryCode = constants.countries[0].value;   

    for (let i = 0; i < constants.languages.length; i++) {
        if (constants.languages[i].selected) {
            var current = constants.languages[i].value;
            current = current.substring(3);
            languageCode = current;
            if (languageCode === 'US') {
                languageCode = "EN";
            }
            break;
        }
    }
    for (let i = 0; i < constants.countries.length; i++) {
        if (constants.countries[i].selected) {
            countryCode = constants.countries[i].value;
            break;
        }
    }

    const dispatch = useDispatch();
    const { modalStatus } = useSelector((state) => state.languageAndCountry);

    return (
        <div className="row">
            <div className="columns small-12">
                <div className="bnr__row">
                    <div className="bnr__item">
                        <button className="bnr__trigger" onClick={() => dispatch(setModalStatus(true))}>
                            <i className="bnr__trigger-icon"></i>
                            <span>{languageCode + ' / ' + countryCode }</span>
                        </button>
                        <Modal
                            isOpen={modalStatus}
                            ariaHideApp={false}
                            contentLabel=""
                            onRequestClose={() => dispatch(setModalStatus(false))}
                            closeTimeoutMS={150}
                            style={ModalStyles}
                        >
                            <div className="modal-close">
                                <CloseButton title={translate('general.close')} onClick={() => dispatch(setModalStatus(false))} />
                            </div>
                            <div className="modal-body">
                                <LanguageAndCountrySelector />
                            </div>
                        </Modal>
                    </div>
                    <div className="bnr__item" dangerouslySetInnerHTML={{ __html: constants.additionalHeaderText1 }} />
                    <div className="bnr__item" dangerouslySetInnerHTML={{ __html: constants.additionalHeaderText2 }} />
                </div>
            </div>
        </div>
    );
}
